import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { AppType, useApp } from '@commenda/utils/useAppContext';

interface IndirectTaxFilingCalendarRedirectProps {
  corporationId: number;
}

const IndirectTaxFilingCalendarRedirect = ({
  corporationId,
}: IndirectTaxFilingCalendarRedirectProps) => {
  const { isReady, replace } = useRouter();
  const { appType } = useApp();
  const calendarPath =
    appType === AppType.AGENT
      ? `/clients/${corporationId}/indirect-tax/filings`
      : `/indirect-tax/${corporationId}/filings`;

  useEffect(() => {
    if (isReady && Number.isFinite(corporationId) && corporationId > 0) {
      replace(calendarPath);
    }
  }, [isReady, replace, calendarPath, corporationId]);

  return null;
};

export default IndirectTaxFilingCalendarRedirect;
